export default __webpack_public_path__ + "static/media/inndex-fund-small-midcap.deb6ec5a.jpg";